import { media, font, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/postcss/lib/postcss.js";
import "../node_modules/postcss-js/index.js";
import "../node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const breakpointLarge = media.queries.large.min;
const breakpointDesktop = media.queries.desktop.min;
const eyebrow = {
  fontWeight: 700,
  color: color.black,
  fontSize: font.size.min,
  lineHeight: 1,
  textTransform: `uppercase`,
  letterSpacing: `.05em`
};
const labelMedium = {
  fontFamily: font.family["sans"],
  fontSize: font.size["sm"],
  lineHeight: `1.42em`,
  [`@media (${breakpointLarge})`]: {
    fontSize: `calc(${font.size["sm"]} + 0.16vw)`
  },
  [`@media (${breakpointDesktop})`]: {
    fontSize: font.size["base"],
    letterSpacing: "0.16em",
    lineHeight: `1.5em`
  }
};
const labelSmall = {
  fontFamily: font.family["sans"],
  fontSize: font.size["sm"],
  letterSpacing: "0.16em",
  lineHeight: `1.42em`
};
const interativeMedium = {
  fontFamily: font.family["sans"],
  fontSize: font.size["base"],
  lineHeight: `1.125em`,
  [`@media (${breakpointLarge})`]: {
    fontSize: `calc(${font.size["base"]} + 0.16vw)`
  },
  [`@media (${breakpointDesktop})`]: {
    fontSize: font.size["lg"],
    fontWeight: font.weight["bold"],
    letterSpacing: "-0.01em",
    lineHeight: `1.11em`
  }
};
const interativeSmall = {
  fontFamily: font.family["sans"],
  fontSize: font.size["base"],
  fontWeight: font.weight["bold"],
  letterSpacing: "-0.01em",
  lineHeight: `1.125em`
};
function compose(type, options) {
  const { theme, color: explicitColor } = options || {};
  const bases = {
    eyebrow,
    labelMedium,
    labelSmall,
    medium: interativeMedium,
    small: interativeSmall
  };
  const base = bases[type];
  const finalColor = explicitColor || (theme === "dark" ? color.white : color.black);
  const composed = {
    ...base,
    ...theme && {
      color: finalColor
    }
  };
  const classNameParts = ["umd-element", type];
  if (theme === "dark") classNameParts.push("dark");
  return objectWithClassName({
    ...composed,
    className: classNameParts.join("-")
  });
}
const fonts = {
  eyebrow: objectWithClassName({
    className: "umd-eyebrow",
    ...eyebrow
  }),
  labelMedium: objectWithClassName({
    className: "umd-label-sans-medium",
    ...labelMedium
  }),
  labelSmall: objectWithClassName({
    className: "umd-label-sans-small",
    ...labelSmall
  }),
  medium: objectWithClassName({
    className: "umd-interactive-sans-medium",
    ...interativeMedium
  }),
  small: objectWithClassName({
    className: "umd-interactive-sans-small",
    ...interativeSmall
  })
};
export {
  compose,
  eyebrow,
  fonts,
  interativeMedium,
  interativeSmall,
  labelMedium,
  labelSmall
};
//# sourceMappingURL=elements.js.map
